import {
  CssVarsType,
  FigmaModesType,
  FigmaVariableType,
  FigmaVariablesMapType,
} from './themeTypes';
import { THEME_MODULE } from './themeContext';

export function updateCssVariable({ key, value }: CssVarsType): void {
  const root = window.document.documentElement;
  root.style.setProperty(key, value);
}

export function updateCssVariables(cssVars: CssVarsType): void {
  const root = window.document.documentElement;

  Object.entries(cssVars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}

export function validateModulePathname(modules: Array<string>, moduleName: string): string {
  return !moduleName.length || !modules.includes(moduleName) ? THEME_MODULE.AUTH : moduleName;
}

const parseFigmaVariables = (arr: FigmaVariableType[]) => {
  const variables: Record<string, string> = {};

  arr.forEach((v) => {
    variables[v.name] = v.value;
  });

  return variables;
};

export const parseFigmaModes = (arr: FigmaModesType[]) =>
  arr.reduce((map, obj) => {
    map[obj.name.toLowerCase() as keyof FigmaVariablesMapType] = parseFigmaVariables(obj.variables);

    return map;
  }, {} as FigmaVariablesMapType);
